import { FC } from 'react';

import { InfoCardProps } from './InfoCard.types';
import { StyledInfoCardContainer } from './InfoCard.styles';

const InfoCard: FC<InfoCardProps> = ({ children, css, hasBorder, separator, testId }) => {
  return (
    <StyledInfoCardContainer css={{ ...css }} data-testid={`${testId ? `${testId}-` : ''}info-card`} hasBorder={hasBorder} separator={separator}>
      {children}
    </StyledInfoCardContainer>
  );
};

export default InfoCard;
